import { makeVar } from '@apollo/client/cache';

// Whether super-admin-backend has accepted our session. The session cookie is
// HttpOnly, so this starts false and is set from the `me` query.
export const isSignedInVar = makeVar<boolean>(false);
